export function useLightgalleryState({
  galleryId,
  dynamicItems,
  allItems = [],
  itemsToShow = 1,
}: {
  galleryId: string
  dynamicItems: ComputedRef<any[]>
  allItems?: any[]
  itemsToShow?: number
}) {
  let lightgalleryRef: any
  const isLightboxOpened = ref(false)

  const visibleItems = computed(() => {
    return allItems.slice(0, itemsToShow)
  })

  const moreItemsCount = computed(() => {
    return allItems.length - itemsToShow
  })

  function onAfterOpen() {
    window.history.pushState({}, '')

    isLightboxOpened.value = true
  }

  function onAfterClose() {
    if (!isLightboxOpened.value) {
      return
    }

    window.history.back()
  }

  // TODO: close only when lightbox popstate is triggered
  function onPopState() {
    if (!lightgalleryRef || !isLightboxOpened.value) {
      return
    }

    lightgalleryRef.value.LG.closeGallery()
    isLightboxOpened.value = false
  }

  function openGalleryAtIndex(index: number) {
    if (!lightgalleryRef) {
      return
    }

    const lightgalleryInstance = lightgalleryRef.value.LG

    lightgalleryInstance.openGallery(index)
  }

  function setLightgalleryRef(ref: any) {
    lightgalleryRef = ref
  }

  onMounted(() => {
    window.addEventListener('popstate', onPopState)
  })

  onUnmounted(() => {
    window.removeEventListener('popstate', onPopState)
  })

  return {
    galleryId,
    itemsToShow,
    isLightboxOpened,
    onAfterOpen,
    onAfterClose,
    visibleItems,
    moreItemsCount,
    openGalleryAtIndex,
    dynamicItems,
    setLightgalleryRef,
  }
}
